<!-- <div class="modal">
  <div class="modal-content">
    <h2>{{ isBlocking ? 'Block' : 'Unblock' }} Record</h2>
    <p>Are you sure you want to {{ isBlocking ? 'block' : 'unblock' }} this record?</p>
    <button (click)="onConfirm()">Yes</button>
    <button (click)="onCancel()">No</button>
  </div>
</div> -->
<!-- <div class="modal-overlay"></div> -->
<!-- Overlay -->

<!-- <div class="modal" tabindex="-1">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{ isBlocking ? 'Block' : 'Unblock' }} Record</h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
          (click)="onCancel()"
        ></button>
      </div>
      <div class="modal-body">
        <p>Are you sure you want to {{ isBlocking ? 'block' : 'unblock' }} this record?</p>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary me-2"
          data-bs-dismiss="modal"
          (click)="onCancel()"
        >
          Close
        </button>
        <button type="button" class="btn btn-primary" (click)="onConfirm()">Save changes</button>
      </div>
    </div>
  </div>
</div> -->

<div class="modal-header">
  <h5 class="modal-title">{{ title || (isBlocking ? 'Inactive' : 'Active') }}</h5>
  <button type="button" class="close" aria-label="Close" (click)="onCancel()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <p *ngIf="!title">
    Are you sure you want to {{ isBlocking ? 'inactive' : 'active' }} this record?
  </p>
  <p *ngIf="title">{{ desc }}?</p>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary me-2" (click)="onCancel()">Cancel</button>
  <button type="button" class="btn btn-primary" (click)="onConfirm()">Confirm</button>
</div>
